import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_DONATION_SUMMARY = 'REQUEST_DONATION_SUMMARY'
export const RECEIVE_DONATION_SUMMARY = 'RECEIVE_DONATION_SUMMARY'
const SAVE_DONATION_SUMMARY = 'SAVE_DONATION_SUMMARY'

export const requestDonationSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_DONATION_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/donationsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveDonationSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveDonationSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveDonationSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveDonationSummary = (data) => ({ type: RECEIVE_DONATION_SUMMARY, data })

const saveDonationSummary = (data) => (dispatch) => {
    dispatch({ type: SAVE_DONATION_SUMMARY, data })

    const { taxReturnId } = data

    return axios
        .put(`/donationsummaries/${taxReturnId}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveDonationSummary(responseData))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveDonationSummary = (data) => (dispatch) => {
    dispatch(receiveDonationSummary(data))
    return dispatch(saveDonationSummary(data)).catch(() => {})
}
